import { render, staticRenderFns } from "./BaseBannerMessaging.vue?vue&type=template&id=3e5afa61&scoped=true&"
import script from "./BaseBannerMessaging.vue?vue&type=script&lang=ts&"
export * from "./BaseBannerMessaging.vue?vue&type=script&lang=ts&"
import style0 from "./BaseBannerMessaging.vue?vue&type=style&index=0&id=3e5afa61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5afa61",
  null
  
)

export default component.exports